/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $WriteModule = {
    description: `Write a new module or update an existing one`,
    properties: {
        address: {
            type: 'Address',
            isRequired: true,
        },
        state_key_hash: {
            type: 'string',
            description: `State key hash`,
            isRequired: true,
        },
        data: {
            type: 'MoveModuleBytecode',
            isRequired: true,
        },
    },
} as const;
